import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import config from '../config'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    areas: [],
    assignmentTypes: [],
    calculationResults: [],
  },

  getters: {
    provinces(state) {
      let results = []

      state.areas.forEach(area => {
        if (results.indexOf(area.Province) < 0) {
          results.push(area.Province)
        }
      })

      return results
    },

    totalCharge(state) {
      let total = 0

      state.calculationResults.forEach(i => {
        total += i.Amount
      })

      return total
    },
  },

  mutations: {
    SET_AREAS(state, values) {
      state.areas = values
    },

    SET_ASSIGNMENT_TYPES(state, values) {
      state.assignmentTypes = values
    },

    SET_CALCULATION_RESULTS(state, values) {
      state.calculationResults = values
    },
  },

  actions: {
    initialize({ commit }) {
      const url = config.API_ROOT + 'tariffcalculator/initialize'

      return new Promise((resolve, reject) => {
        axios
          .post(url)
          .then(r => r.data)
          .then(result => {
            if (result.Status && result.Status === 1) {
              commit('SET_AREAS', result.Data.Areas)
              commit('SET_ASSIGNMENT_TYPES', result.Data.AssignmentTypes)
              resolve()
            } else {
              reject(result.Message)
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    calculate({ commit }, args) {
      const url = config.API_ROOT + 'tariffcalculator/calculate'

      return new Promise((resolve, reject) => {
        const data = {
          AreaId: args.areaId,
          VesselLength: args.vesselLength,
          VesselBreadth: args.vesselBreadth,
          VesselDepth: args.vesselDepth,
          VesselGrt: args.vesselGrt,
          AreDimensionsMetric: args.vesselUnits === 'M',
          AssignmentType: args.assignmentTypeId,
          ExpectedDuration: args.expectedDuration,
          ExpectedDraft: args.exectedDraft,
          IsDraftInMetric: args.draftUnits === 'M',
          IsPilotBoatNeeded: args.needPilotBoat === 'Y',
        }

        axios
          .post(url, data)
          .then(r => r.data)
          .then(result => {
            if (result.Status && result.Status === 1) {
              commit('SET_CALCULATION_RESULTS', result.Data)

              resolve()
            } else {
              reject(result.Message)
            }
          })
          .catch(err => {
            reject(err)
          })
      })
    },
  },
  modules: {},
})
